jQuery(document).ready(function($) {
  if ($('body').hasClass('template-collection')) {

    //==================================================================================
    //** COLLECTION PRODUCT CARD SWIPER (robust ready detection)
    //==================================================================================
    function isMobileBP() { return window.matchMedia('(max-width: 989.98px)').matches; }

    function waitForSwiper(el, cb, tries) {
      tries = (tries || 0);
      if (el.swiper) return cb(el.swiper);
      if (tries > 120) return cb(null); // ~2s fallback at 60fps
      requestAnimationFrame(function(){ waitForSwiper(el, cb, tries + 1); });
    }

    function markReady(el) {
      if (el.getAttribute('data-state') !== 'ready') el.setAttribute('data-state','ready');
    }

    function watchImages(el) {
      if (el.__jciImgsWatched) return;
      el.__jciImgsWatched = true;

      var imgs = el.querySelectorAll('img');
      if (!imgs.length) { markReady(el); return; }

      var remaining = 0;
      function done(){ if (--remaining <= 0) markReady(el); }

      imgs.forEach(function(img){
        if (!(img instanceof HTMLImageElement)) return;
        remaining++;
        if (img.complete && img.naturalWidth > 0) { done(); }
        else {
          img.addEventListener('load',  done, { once:true });
          img.addEventListener('error', done, { once:true });
        }
      });
      if (remaining === 0) markReady(el);
    }

    function initOrUpdateOne(el) {
      // if already initialized + ready, just update sizes and bail
      if (el.swiper && el.getAttribute('data-state') === 'ready') {
        try { el.swiper.update(); } catch(e){}
        return;
      }

      // already initialized but not marked? mark & update
      if (el.swiper && el.getAttribute('data-state') !== 'ready') {
        markReady(el);
        try { el.swiper.update(); } catch(e){}
        return;
      }

      // not initialized yet: show loader and init
      if (el.getAttribute('data-state') !== 'ready') el.setAttribute('data-state','loading');

      try { el.initialize(); } catch(e){}

      if (!el.__jciEventsBound) {
        el.__jciEventsBound = true;

        // Swiper events (some builds don’t always emit imagesReady)
        waitForSwiper(el, function(sw){
          if (!sw) return; // image watcher + fallback will still flip
          try {
            sw.on('imagesReady', function(){ markReady(el); });
            sw.on('init', function(){
              setTimeout(function(){ markReady(el); try { sw.update(); } catch(e){} }, 50);
            });
          } catch(e){}
          // nudge update next frame too (helps on resize into mobile)
          requestAnimationFrame(function(){ try { sw.update(); } catch(e){} });
        });

        // also rely on actual <img> loads
        watchImages(el);

        // last resort: never leave user staring at shimmer
        el.__jciFallbackTimer = setTimeout(function(){
          if (el.getAttribute('data-state') !== 'ready') markReady(el);
        }, 2500);
      }
    }

    function enableCardSwipersIn(root) {
      if (!isMobileBP()) return;
      var scope = root || document;
      scope.querySelectorAll('swiper-container.jci-card-swiper').forEach(initOrUpdateOne);
    }

    function ensureSwiperAndEnable(root) {
      if (customElements.get('swiper-container')) { enableCardSwipersIn(root); return; }
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-element-bundle.min.js';
      s.onload = function(){ enableCardSwipersIn(root); };
      document.head.appendChild(s);
    }

    /* 1) initial load */
    if (isMobileBP()) ensureSwiperAndEnable(document);

    /* 2) when viewport crosses into mobile */
    (function(){
      var mq = window.matchMedia('(max-width: 989.98px)');
      function onChange(e){
        if (e.matches) {
          ensureSwiperAndEnable(document);
          // ensure any pre-rendered sliders are updated and shown
          document.querySelectorAll('swiper-container.jci-card-swiper').forEach(function(el){
            if (el.swiper) { markReady(el); try { el.swiper.update(); } catch(e){} }
          });
        }
      }
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else mq.addListener(onChange);
    })();

    /* 3) load-more / infinite scroll: only touch newly added nodes */
    (function(){
      var grid = document.getElementById('product-grid');
      if (!grid) return;

      var mo = new MutationObserver(function(muts){
        if (!isMobileBP()) return;
        var newRoots = [];
        muts.forEach(function(m){
          if (!m.addedNodes) return;
          m.addedNodes.forEach(function(n){
            if (n.nodeType === 1) newRoots.push(n);   // ELEMENT_NODE
          });
        });
        if (!newRoots.length) return;
        requestAnimationFrame(function(){
          newRoots.forEach(function(root){ ensureSwiperAndEnable(root); });
        });
      });

      mo.observe(grid, { childList: true, subtree: true });
    })();

    /* 4) theme AJAX events (optional safety) */
    $(document).on('collection:updated shopify:section:load', function(){
      if (isMobileBP()) ensureSwiperAndEnable(document);
    });

    //==================================================================================
    //** TOGGLE VIEW SHOWING 1 OR 2 PRODUCTS PER ROW FOR MOBILE
    //==================================================================================
    const $grid = $('#product-grid');
    const $btns = $('.jci-view-btn');
    const LS_KEY = 'jci_view_mode';


    function applyView(mode) {
      mode = String(mode); // normalize 1/2 to '1'/'2'

      if (mode === '2') {
        $(document).find(`#product-grid`).addClass('grid--2-col-tablet-down')
            .removeClass('grid--1-col-tablet-down');
      } else {
        $(document).find(`#product-grid`).addClass('grid--1-col-tablet-down')
            .removeClass('grid--2-col-tablet-down');
      }

      $btns.each(function() {
        const isActive = String($(this).data('grid')) === mode;
        $(this).toggleClass('active', isActive)
              .attr('aria-pressed', isActive);
      });

      try { localStorage.setItem(LS_KEY, mode); } catch (e) {}
    }


    $(document).on('click', '.jci-view-btn', function() {
      applyView($(this).data('grid'));
    });
    /*
    // click handlers
    $btns.on('click', function() {
      applyView($(this).data('grid')); // may be 1/2 (number)
    });
    */

    // initialize (respect storage or existing DOM classes)
    let initial = '2';
    try { initial = localStorage.getItem(LS_KEY) || initial; } catch (e) {}
    if ($grid.hasClass('grid--1-col-tablet-down')) initial = '1';
    if ($grid.hasClass('grid--2-col-tablet-down')) initial = '2';

    applyView(initial);
  }


  //==================================================================================
  //** WISHLIST (delegated + load-more safe)
  //==================================================================================

  const wishlistKey = 'jciWishlist';

  // 1) Update the little count bubble (UNCHANGED)
  function updateWishlistCount() {
    const wishlist    = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
    const count       = wishlist.length;
    const $bubble     = $('.wishlist-count-bubble');
    const $bubbleSpan = $bubble.find('span');

    if (count > 0) {
      $bubbleSpan.text(count);
      $bubble.show();
    } else {
      $bubbleSpan.empty();
      $bubble.hide();
    }
  }

  // Helper: robustly get product handle for a heart
  function getHandleFromTrigger($btn){
    // if you ever add data-handle directly
    const direct = $btn.attr('data-handle');
    if (direct) return direct;

    // current markup: heart sibling is <a.custom-pg data-product-handle="">
    let $link = $btn.siblings('a.custom-pg');
    if (!$link.length) $link = $btn.closest('.jci-product-card-wrapper').find('a.custom-pg').first();
    return $link.data('product-handle');
  }

  // Sync hearts' active state from localStorage (run on load & after "load more")
  function syncWishlistHearts(root){
    const handles = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
    (root ? $(root) : $(document)).find('.jci-wishlist-trigger').each(function(){
      const $btn = $(this);
      const handle = getHandleFromTrigger($btn);
      const on = handle && handles.includes(handle);
      $btn.toggleClass('active', on).attr('aria-pressed', on ? 'true' : 'false');
    });
  }

  // 2) Toggle a heart & persist handles (DELEGATED so it works for new cards)
  $(document)
    .off('click.jciWish', '.jci-wishlist-trigger')
    .on('click.jciWish', '.jci-wishlist-trigger', function(e){
      e.preventDefault();
      e.stopPropagation(); // don’t trigger the product <a>
      const $btn   = $(this);
      const handle = getHandleFromTrigger($btn);
      if (!handle) return;

      let wishlist = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
      const idx = wishlist.indexOf(handle);

      if (idx === -1) {
        wishlist.push(handle);
        $btn.addClass('active').attr('aria-pressed','true');
      } else {
        wishlist.splice(idx, 1);
        $btn.removeClass('active').attr('aria-pressed','false');
      }

      localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
      updateWishlistCount();
    });

  // 3) Show / Hide the wishlist popup, fetching .js data (KEPT, with tiny sync hook)
  function showWishlistPopup() {
    const handles = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
    const $popup   = $('#jci-wishlist-popup');
    const $loading = $popup.find('.jci-wishlist-loading');
    const $items   = $popup.find('.jci-wishlist-items');

    $items.hide().empty();
    $loading.show();
    $popup.fadeIn(200);

    if (!handles.length) {
      setTimeout(() => {
        $loading.hide();
        $items.html('<p>Your wishlist is empty.</p>').show();
      }, 300);
      return;
    }

    let remaining = handles.length;
    handles.forEach(handle => {
      fetch(`/products/${handle}.js`)
        .then(r => r.json())
        .then(prod => {
          // Get a proper image URL
          let src = '';
          if (prod.featured_image) {
            src = typeof prod.featured_image === 'string' ? prod.featured_image : prod.featured_image.src;
          } else if (prod.images && prod.images.length) {
            src = prod.images[0];
          }
          const imgUrl = src ? src.replace(/(\.\w+)(\?.*)?$/, '_600x600$1') : '';

          const price        = (prod.price / 100).toFixed(2);
          const comparePrice = prod.compare_at_price > prod.price ? (prod.compare_at_price / 100).toFixed(2) : null;
          const compareHTML  = comparePrice ? `<strike>$${comparePrice}</strike>` : '';

          const card = `
            <div class="jci-wishlist-item">
              <button class="jci-wishlist-remove" data-handle="${prod.handle}">×</button>
              <a href="${prod.url}">
                <img src="${imgUrl}" />
                <div>
                  <p>${prod.title}</p>
                  <p>${compareHTML}<span>$${price}</span></p>
                </div>
              </a>
            </div>`;
          $items.append(card);
        })
        .catch(console.error)
        .finally(() => {
          if (--remaining === 0) {
            $loading.hide();
            $items.show();
          }
        });
    });
  }

  function hideWishlistPopup() {
    $('#jci-wishlist-popup').fadeOut(200);
  }

  // Popup open/close bindings (KEPT)
  $(document).on('click', '.header__icon--wishlist', showWishlistPopup);
  $(document).on('click', '#jci-wishlist-close', hideWishlistPopup);
  // Close when clicking outside the content area (KEPT)
  $(document).on('click', '#jci-wishlist-popup', function(e){
    if (e.target.id === 'jci-wishlist-popup') hideWishlistPopup();
  });

  // Remove single item from popup (delegated + sync hearts)
  $(document)
    .off('click.jciWishRemove', '.jci-wishlist-remove')
    .on('click.jciWishRemove', '.jci-wishlist-remove', function(e) {
      e.preventDefault();
      e.stopPropagation(); // don’t close popup
      const handle = $(this).data('handle');
      let wishlist = JSON.parse(localStorage.getItem(wishlistKey) || '[]').filter(h => h !== handle);
      localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
      updateWishlistCount();
      syncWishlistHearts(document);
      $(this).closest('.jci-wishlist-item').remove();

      if (wishlist.length === 0) {
        $('.jci-wishlist-items').html('<p>Your wishlist is empty.</p>');
      }
    });

  // 4) Initialization on page load (REPLACED restore loop with sync)
  syncWishlistHearts(document);
  updateWishlistCount();

  // Re-sync hearts when new products are appended (load more / infinite)
  (function(){
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    const mo = new MutationObserver(function(muts){
      muts.forEach(function(m){
        m.addedNodes && m.addedNodes.forEach(function(n){
          if (n.nodeType === 1) syncWishlistHearts(n); // only the new subtree
        });
      });
    });
    mo.observe(grid, { childList: true, subtree: true });
  })();

  // Optional: if your theme fires ajax/section events
  $(document).on('collection:updated shopify:section:load', function(){
    syncWishlistHearts(document);
  });

  // $('.template-collection .custom-hide-filter-btn').click();

  /*
  let isCollectionPg = $('body').hasClass('template-collection');
  let isProductPg = $('body').hasClass('template-product');

  if(isCollectionPg) {
    $('.custom-apply-filter-btn').click(function() {
      $('.custom-hide-filter-btn').click()
    })
  }
  */

  // if(isProductPg) {
  //   // 1) cache the price block and its original parent
  //   var $price       = $('#price-template--17874687459398__main');
  //   var $stars       = $('.product__info-container > div').eq(1);
  //   var $description = $('.product-detail-mob-cls > p');
  //   var $original    = $price.parent();
  //   var $mediaH1 = $('.pd-main-product__media h1.pd-main-product__title').first();
  //   var $uppercaseText = $('.product__text.pd-main-product__text.uppercase');
  //   var $designSwatches = $('.swiper-wrapper.pd-main-product__design-swatches__items');
    
  //   // 2) insert a placeholder so we know where to put it back
  //   var $placeholder = $('<div id="price-placeholder"></div>');
  //   $price.before($placeholder);

  //   function updatePricePosition() {
  //     var w = $(window).width();
  //     if (w < 750) {
  //       // move it under the media <h1>
  //       if (!$mediaH1.next().is($price)) {
  //         $price.insertAfter($mediaH1);
  //       }
  //       // swap stars & description
  //       if (!$description.next().is($stars)) {
  //         $description.insertAfter($stars);
  //       }
  //       // move uppercase text after description
  //       if (!$description.next().is($uppercaseText)) {
  //         $uppercaseText.insertBefore($description);
  //       }
  //       // move design swatches before description
  //       // if ( !$description.prev().is($designSwatches) ) {
  //       //   $designSwatches.insertBefore($description);
  //       // }
  //     } else {
  //       // move it back to its placeholder
  //       if (!$('#price-placeholder').next().is($price)) {
  //         $price.insertAfter($placeholder);
  //       }
  //     }
  //   }

  //   // run once, then on resize
  //   updatePricePosition();
  //   $(window).on('resize', updatePricePosition);
  // }
  
  
})




document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector('.custom-plp-collection-list-ul');
  const indicator = document.querySelector('.custom-scroll-indicator');

  if (wrapper && indicator) {
    const hideArrowOnScroll = () => {
      if (wrapper.scrollLeft > 10) {
        indicator.classList.add('hidden');
      }
    };

    wrapper.addEventListener('scroll', hideArrowOnScroll, { passive: true });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const desc = document.getElementById("coll-description-inner");
  const toggle = document.getElementById("coll-description-toggle");

  if (!desc || !toggle) return;

  // Use em-based max height as defined in CSS
        // const maxHeightEm = window.innerWidth <= 468 ? 4.6 : 6.3;
        // const fontSize = parseFloat(getComputedStyle(desc).fontSize); // get px value of 1em
        // const maxHeightPx = maxHeightEm * fontSize;
  const maxLines = 2;
  const fontSize = parseFloat(getComputedStyle(desc).fontSize); // e.g., 16px
  const lineHeight = parseFloat(getComputedStyle(desc).lineHeight) || fontSize * 1.2; // fallback if lineHeight is 'normal'

  const textHeight = desc.scrollHeight;
  const twoLineHeight = maxLines * lineHeight;


  // Allow layout to complete before checking height
  requestAnimationFrame(() => {
    // const isOverflowing = desc.scrollHeight > maxHeightPx + 1; // +1px buffer

    if (textHeight > twoLineHeight) {
      toggle.style.display = "inline-block";
      // desc.style.maxHeight = `${maxHeightEm}em`;
       
      toggle.addEventListener("click", function () {
        const expanded = desc.classList.toggle("expanded");
        toggle.textContent = expanded ? "Read less" : "Read more";
        desc.style.display = expanded ? "inline-block" : "-webkit-box";
      });
    } else {
      toggle.style.display = "none";
    }
  });
});

const scrollArea = document.querySelector('.custom-plp-collection-list-ul');



scrollArea?.addEventListener('wheel', function (e) {
  if (scrollArea.matches(':hover')) {
    e.preventDefault();
    scrollArea.scrollLeft += e.deltaY;
  }
});

const container =  document.querySelector('.custom-plp-collection-list-ul');

let isDown = false;
let startX;
let scrollLeft;

container?.addEventListener('mousedown', (e) => {
  isDown = true;
  container.classList.add('dragging');
  startX = e.pageX;
  scrollLeft = container.scrollLeft;
});

container?.addEventListener('mouseleave', () => {
  isDown = false;
  container.classList.remove('dragging');
});

container?.addEventListener('mouseup', () => {
  isDown = false;
  container.classList.remove('dragging');
});

container?.addEventListener('mousemove', (e) => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX;
  const walk = x - startX;
  container.scrollLeft = scrollLeft - walk;
});


// document.addEventListener("DOMContentLoaded", function () {
//   const showBtn = document.querySelector('.custom-show-filter-btn');
//   const hideBtn = document.querySelector('.custom-hide-filter-btn');
//   const toggleBtn = document.querySelector('.custom-filter-toggle-btn');
//   const activeFacets = document.querySelector('.active-facets.active-facets-desktop');

//   if (!showBtn || !hideBtn || !toggleBtn || !activeFacets) return;

//   // Show Filters Click
//   showBtn.addEventListener('click', function () {
//     toggleBtn.classList.add('jci-hide');
//     activeFacets.classList.remove('jci-hide');
//     showBtn.style.display = 'none';
//   });

//   // Hide Filters Click
//   hideBtn.addEventListener('click', function () {
//     toggleBtn.classList.remove('jci-hide');
//     activeFacets.classList.add('jci-hide');
//     showBtn.style.display = 'inline-block';
//   });
// });













